import uid from "common/utils/uid";
import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_85: DocMigration = {
  maxSchemaVersion: "0.0.85",
  description: "Migrate foundation details to catalog",
  apply(json: any) {
    migrateDoc0086DetailCatalog(json);
    return json;
  },
};

function migrateDoc0086DetailCatalog(json: any) {
  const deprecatedDetailIdToFoundationConditions = {
    EXTERIOR_WALL_FOOTING: {
      conditions: ["INTERIOR_EXTERIOR"],
    },
    BRICK_LEDGE_AT_HOUSE_FOOTING: {
      conditions: ["INTERIOR_BRICKLEDGE_EXTERIOR"],
    },
    INTERIOR_WALL_FOOTING: {
      conditions: ["INTERIOR_INTERIOR", "PORCH_PORCH", "GARAGE_GARAGE"],
    },
    EXTERIOR_PORCH_WALL_FOOTING: {
      conditions: ["PORCH_EXTERIOR", "PORCH_BRICKLEDGE_EXTERIOR"],
    },
    PORCH_AT_HOUSE_FOOTING: {
      conditions: ["INTERIOR_PORCH", "INTERIOR_BRICKLEDGE_PORCH"],
    },
    BRICK_LEDGE_AT_GARAGE_FOOTING: {
      conditions: ["GARAGE_BRICKLEDGE_EXTERIOR"],
    },
    GARAGE_AT_HOUSE_FOOTING: {
      conditions: ["INTERIOR_GARAGE"],
    },
    FLOOR_SLOPE_GARAGE_DOOR_FOOTING: {
      conditions: ["GARAGE_DOOR_EXTERIOR"],
    },
    EXTERIOR_GARAGE_WALL: {
      conditions: ["GARAGE_EXTERIOR"],
    },
    INTERIOR_WALL_SLAB_FOOTING: {
      conditions: [],
    },
    PORCH_COLUMN_CONNECTION: {
      conditions: [],
    },
    EXTERIOR_PORCH: {
      conditions: [],
    },
    VOID: {
      conditions: ["EXTERIOR_EXTERIOR", "GARAGE_BRICKLEDGE_PORCH", "GARAGE_PORCH"],
    },
  };

  if (json.planOutputConfig) {
    if (json.planOutputConfig.foundationPlanConfig) {
      const foundationPlanConfig = json.planOutputConfig.foundationPlanConfig;

      if (foundationPlanConfig.foundationDetailOverrides) {
        const foundationConditions = {};

        for (const override of foundationPlanConfig.foundationDetailOverrides) {
          const { condition: deprecatedId, detailNumber } = override;
          const { conditions } = deprecatedDetailIdToFoundationConditions[deprecatedId];

          for (const foundationCondition of conditions) {
            foundationConditions[foundationCondition] = {
              detailNumber,
            };
          }
        }

        if (Object.keys(foundationConditions).length) {
          let mId = uid();
          let sId = uid();

          if (json.settingsOverride) {
            mId = json.settingsOverride.foundationSlabMonolithic ?? mId;
            sId = json.settingsOverride.foundationSlabStemWall ?? sId;
            json.settingsOverride = {
              ...json.settingsOverride,
              foundationSlabMonolithic: mId,
              foundationSlabStemWall: sId,
            };
          } else {
            json.settingsOverride = {
              foundationSlabMonolithic: mId,
              foundationSlabStemWall: sId,
            };
          }

          const foundationSlabMonolithic = json.settings[mId] ?? {
            type: "FOUNDATION_SLAB_SETTINGS_MONO",
          };

          const foundationSlabStemWall = json.settings[sId] ?? {
            type: "FOUNDATION_SLAB_SETTINGS_STEM",
          };

          foundationSlabMonolithic["foundationConditions"] = { ...foundationConditions };
          foundationSlabStemWall["foundationConditions"] = { ...foundationConditions };

          json.settings[mId] = foundationSlabMonolithic;
          json.settings[sId] = foundationSlabStemWall;
        }
      }
    }

    delete json["planOutputConfig"];
  }

  return json;
}

export default migration_0_0_85;
